<div [id]="divId">
    <svg width="108px" height="104px">
        <g class="map"></g>
    </svg>
</div>